import { c as _c } from "react/compiler-runtime";
import { TaxYearlyReportUnits } from "../../../../../models";
import { thousandize } from "../../../../../util/formatting";
import style from "./TaxYearlyReportMobileDetails.module.scss";
export const TaxYearlyReportMobileDetails: React.FC<{
  channels: {
    channel: string;
    sumDonations: number;
  }[];
  unit?: TaxYearlyReportUnits;
}> = t0 => {
  const $ = _c(24);
  const {
    channels,
    unit
  } = t0;
  let noUnitSum;
  if ($[0] !== channels || $[1] !== unit) {
    noUnitSum = 0;
    if (!unit) {
      channels.forEach(channel => {
        noUnitSum = noUnitSum + channel.sumDonations;
        noUnitSum;
      });
    }
    $[0] = channels;
    $[1] = unit;
    $[2] = noUnitSum;
  } else {
    noUnitSum = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <td>Identifikator</td>;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = unit ? unit.ssn : "-";
  let t3;
  if ($[4] !== t2) {
    t3 = <tr>{t1}<td>{t2}</td></tr>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== channels || $[7] !== unit) {
    let t5;
    if ($[9] !== unit) {
      t5 = channel_0 => <tr key={channel_0.channel + "-" + (unit ? unit.id : "missing")}><td>{"Gitt gjennom " + channel_0.channel}</td><td>{thousandize(channel_0.sumDonations)} kr</td></tr>;
      $[9] = unit;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = channels.map(t5);
    $[6] = channels;
    $[7] = unit;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <td>Sum donasjoner</td>;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = unit ? unit.sumDonations : noUnitSum;
  let t7;
  if ($[12] !== t6) {
    t7 = thousandize(t6);
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <tr>{t5}<td>{t7} kr</td></tr>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <td>Skattefradrag</td>;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = unit ? thousandize(unit.taxDeduction) + " kr" : "-";
  let t11;
  if ($[17] !== t10) {
    t11 = <tr>{t9}<td>{t10} </td></tr>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11 || $[20] !== t3 || $[21] !== t4 || $[22] !== t8) {
    t12 = <table className={style.table} cellSpacing="0"><tbody>{t3}{t4}{t8}{t11}</tbody></table>;
    $[19] = t11;
    $[20] = t3;
    $[21] = t4;
    $[22] = t8;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};